export const CrosswalkColors = {
  BLUE: '#28aae1',
  ORANGE: '#f49d22',
};
